$('.js-product-read-more').on('click', function (e) {
  e.preventDefault();

  $([document.documentElement, document.body]).animate({
    scrollTop: $('.js-product-description').offset().top - $('.Header__Wrapper').outerHeight(),
  }, 1500);
});

/**
 * Product confirmation acitons
 */
$('.js-product-confirm-bg, .js-product-confirm-close').on('click', function(e) {
  e.preventDefault();
  $('.js-product-confirm').removeClass('open');
});

/**
 * Add to cart
 */
var showProductConfirm = function(data) {
  var $confirmBox = $('.js-product-confirm');
  $confirmBox.find('.js-confirm-title').text(data.product_title);
  $confirmBox.find('.js-confirm-variant').text(data.variant_title);
  $confirmBox.find('.js-confirm-image').attr('src', data.image);
  $confirmBox.addClass('open');

  var changeFocus = function() {
    $confirmBox.focus();
    $confirmBox.off('transitionend', changeFocus);
  }

  $confirmBox.on('transitionend', changeFocus);

};

var toggleCartLoading = function(show) {
  var loadingClass = 'loading';
  var $addtocartBtnWrap = $('.js-product-addtocart-wrap');

  if (show) {
    $addtocartBtnWrap.addClass(loadingClass);
  } else {
    $addtocartBtnWrap.removeClass(loadingClass);
  }
}

$('.ProductForm__AddToCartWrap').on('click', '.ProductForm__AddToCart', function(e) {
  e.preventDefault();

  var productId = $('.js-product-id').val();
  var productQty = +$('.js-product-qty').val();
  
  var data = {
    quantity: productQty,
    id: productId
  };
  
  var $preorder = $('#preorder-note');
  if ($preorder.length) {
    data['properties[Note]'] = $preorder.val();
  }

  var $finalSaleNote = $('.js-final-sale-note');
  if ($finalSaleNote.length) {
    data[$finalSaleNote.attr('name')] = $finalSaleNote.val();
  }

  toggleCartLoading(true);

  // Add To Cart API Call
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(data) {
      updateCartCount(productQty);
      showProductConfirm(data);
      toggleCartLoading(false);
      addFreeGiftToCart();
    },
    error: function(error, textStatus) {
      console.log(error);
      console.log(textStatus);
      toggleCartLoading(false);
    }
  };

  $.ajax(params);
});

/**
 * Size Guide
 */
var $sizeGuide = $('.js-size-guide-modal');
if ($sizeGuide.length) {
  var intro = $sizeGuide.data('intro');
  var table = $sizeGuide.data('table');
  var tips = $sizeGuide.data('tips') ? $sizeGuide.data('tips').split(',') : [];
  var img = $sizeGuide.data('img');

  if (intro) {
    $sizeGuide.find('.js-size-guide-intro.' + intro).show();
  }

  if (table) {
    $sizeGuide.find('.js-size-guide-table.' + table).show();
  }

  if (img) {
    var $img = $sizeGuide.find('.js-size-guide-img.' + img);
    $img.attr('src', $img.data('src')).show();
  }

  tips.forEach(function(item) {
    $sizeGuide.find('.js-size-guide-tip.' + item).show();
  });
}

/**
 * Color specific images on product page
 */
if ($('body').hasClass('template-product')) {
  var productColorSwatch = $('.Product__Info .ProductForm__Variants .ColorSwatch__Radio');
  var slideshowCells;
  var slideshowThumbnails;

  // Slider video button setup
  (function() {
    var $videoLink = $('.js-slideshow-video-link');

    if ($videoLink.length) {
      window.productSlideshow.flickityInstance.on('select', function() {
        if (window.productSlideshow.flickityInstance.selectedIndex === 0) {
          $videoLink.css({ display: 'flex' });
        } else {
          $videoLink.hide();
        }
      });

      $videoLink.on('click', function(e) {
        e.preventDefault();
        var videoId = $(this).data('video-id');
        var cellIdx = window.productSlideshow.flickityInstance.cells.findIndex(function(cell) {
          return $(cell.element).data('media-id') === videoId;
        });
        window.productSlideshow.selectCell(cellIdx);
      });
    }
    
    console.log('called here');
  })();

  const updateFixedATCColorPreview = function(color) {
    const colorSwatch = $('.Product__FixedCTA .ColorSwatchList .ColorSwatch__Radio:checked');
    const backgroundImage = colorSwatch.next('label').css('background-image');
    colorSwatch.closest('.ProductForm__Option').find('.ProductForm__SelectedValue').css('background-image', backgroundImage);
  };

  updateFixedATCColorPreview();

  // Toggle visible images
  var showOnlyColorImages = function(color) {
    // Desktop thumbnails
    var $slideshowNavScroller = $('.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller');
    $slideshowNavScroller.slick('slickUnfilter');
    $slideshowNavScroller.slick('slickFilter', function() {
      var navImage = $(this);
      var imageColor = navImage.data('image-color');

      if (imageColor === color || imageColor === '' || !imageColor) {
        return true;
      } else {
        return false;
      }
    });

    $slideshowNavScroller.find('.Product__SlideshowNavImage').removeClass('is-selected');
    $slideshowNavScroller.find('.Product__SlideshowNavImage').first().addClass('is-selected');

    // $('.Product__SlideshowNav .Product__SlideshowNavImage').each(function() {
    //   var navImage = $(this);
    //   var imageColor = navImage.data('image-color');

    //   if (imageColor === color || imageColor === '' || !imageColor) {
    //     navImage.show();
    //   } else {
    //     navImage.hide();
    //   }
    // });

    // Mobile slideshow
    var visibleSlideshowCells = slideshowCells.filter(function(cell) {
      return cell.dataset.imageColor === color || cell.dataset.imageColor === '' || !cell.dataset.imageColor;
    });

    var slideshow = window.productSlideshow.flickityInstance;
    slideshow.remove(slideshowCells);
    slideshow.append(visibleSlideshowCells);
    slideshow.select(0, true, true);
  };

  var toggleHideBisClass = function(hide) {
    if (hide) {
      $('.Product__Info').addClass('Product__Info--hide-bis');
    } else {
      $('.Product__Info').removeClass('Product__Info--hide-bis');
    }
  };

  $('.Product__FixedCTA .SizeSwatchList .SizeSwatch__Radio').on('change', function(e) {
    e.preventDefault();
    var selectedSize = $(this).val();
    var $preselectSizeItem = $('.Product__Info .ProductForm__Variants .SizeSwatch__Radio').filter('[value="' + selectedSize + '"]');
    $preselectSizeItem.prop('checked', true);
    $preselectSizeItem.each(function() {
      $(this)[0].dispatchEvent(new Event('change', { 'bubbles': true }));
    });

    updateFixedATCColorPreview();
  });

  $('.Product__Info .ProductForm__Variants .SizeSwatch__Radio').on('change', function(e) {
    e.preventDefault();
    var selectedSize = $(this).val();
    var $preselectSizeItem = $('.Product__FixedCTA .SizeSwatch__Radio').filter('[value="' + selectedSize + '"]');
    $preselectSizeItem.prop('checked', true);

    var selectedValue = $preselectSizeItem.closest('.ProductForm__Option').find('.ProductForm__SelectedValue');
    console.log(selectedValue);
    selectedValue.html(selectedSize);
  });

  // Handle color change
  $('.Product__WrapperSide--left .ColorSwatchList .ColorSwatch__Radio').on('change', function(e) {
    e.preventDefault();
    var selectedColor = $(this).data('color');
    var $preselectColorItem = productColorSwatch.filter('[data-color-handle="' + selectedColor + '"]');
    $preselectColorItem.prop('checked', true);
    $preselectColorItem.each(function() {
      $(this)[0].dispatchEvent(new Event('change', { 'bubbles': true }));
    });
  });

  $('.Product__FixedCTA .ColorSwatchList .ColorSwatch__Radio').on('change', function(e) {
    e.preventDefault();
    var selectedColor = $(this).data('color');
    var $preselectColorItem = productColorSwatch.filter('[data-color-handle="' + selectedColor + '"]');
    $preselectColorItem.prop('checked', true);
    $preselectColorItem.each(function() {
      $(this)[0].dispatchEvent(new Event('change', { 'bubbles': true }));
    });
  });

  $('.Product__FixedCTA .ColorSwatchList .ColorSwatch__Radio').on('change', function(e) {
    e.preventDefault();
    var selectedColor = $(this).data('color');
    var $preselectColorItem = productColorSwatch.filter('[data-color-handle="' + selectedColor + '"]');
    $preselectColorItem.prop('checked', true);
    $preselectColorItem.each(function() {
      $(this)[0].dispatchEvent(new Event('change', { 'bubbles': true }));
    });
  });

  productColorSwatch.on('change', function(e) {
    e.preventDefault();
    var selectedColor = $(this).data('color');
    var selectedColorSimple = $(this).data('colorSimple');
    showOnlyColorImages(selectedColor);    

    $('.Product__Bundle .ProductItem').each(function() {
      var $item = $(this);
      var $preselectColorItem = $item.find('.ColorSwatch__Radio[data-color-handle="' + selectedColor + '"]');
      var $preselectSimpleColorItem = $item.find('.ColorSwatch__Radio[data-color-simple="' + selectedColorSimple + '"]');

      if ($preselectColorItem.length) {
        $preselectColorItem.first().prop('checked', true);
        if ($preselectColorItem[0]) {
          $preselectColorItem[0].dispatchEvent(new Event('change', { 'bubbles': true }));
        }
      } else if ($preselectSimpleColorItem.length) {
        $preselectSimpleColorItem.first().prop('checked', true);
        $preselectSimpleColorItem[0].dispatchEvent(new Event('change', { 'bubbles': true }));
      }
    });
    
    var event = new CustomEvent('uvs:productColorChanged', {
      detail: {
        color: selectedColor,
        simpleColor: selectedColorSimple,
      }
    });
    document.dispatchEvent(event);

    $('.Product__WrapperSide--left .ColorSwatchList').each(function() {
      var $item = $(this);
      var $preselectColorItem = $item.find('.ColorSwatch__Radio[data-color-handle="' + selectedColor + '"]');
      $preselectColorItem.first().prop('checked', true);
    });

    $('.Product__FixedCTA .ColorSwatchList').each(function() {
      var $item = $(this);
      var $preselectColorItem = $item.find('.ColorSwatch__Radio[data-color-handle="' + selectedColor + '"]');
      $preselectColorItem.first().prop('checked', true);

      updateFixedATCColorPreview();
    });

    toggleHideBisClass($(this).data('hide-bis'));
  });

  toggleHideBisClass($('.ProductForm__Variants .ColorSwatch__Radio:checked').data('hide-bis'));

  $('[data-fixed-atc-scroll]').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('.Product__Info .ProductForm').offset().top - 200
    }, 1000);
  });


  if (productColorSwatch.length === 0) {
    $('.Product__Bundle .ProductItem').each(function() {
      var $item = $(this);
      var $preselectColorItem = $item.find('.ColorSwatch__Radio').first();

      if ($preselectColorItem.length) {
        $preselectColorItem.prop('checked', true);
        if ($preselectColorItem[0]) {
          $preselectColorItem[0].dispatchEvent(new Event('change', { 'bubbles': true }));
        }
        $item.find('.js-product-images-main').addClass('Image--lazyLoad');
      }
    });
  }

  
  // Get elements
  if (window.productSlideshow) {
    slideshowCells = window.productSlideshow.flickityInstance.getCellElements();
  }

  // Initial color switch
  if (productColorSwatch.length) {
    const $selectedItem = productColorSwatch.filter(':checked');
    var initialColor = $selectedItem.data('color');
    var initialSimpleColor = $selectedItem.data('color-simple');
    
    showOnlyColorImages(initialColor);

    var event = new CustomEvent('uvs:productColorChanged', {
      detail: {
        color: initialColor,
        simpleColor: initialSimpleColor,
      }
    });
    document.dispatchEvent(event);
  }
}


/**
 * Personalized tracking
 */
if (localStorage) {
  var STORAGE_KEY = 'pxt_collection_engagement';
  var productBreadcrumbs = $('.Breadcrumbs');  

  if (productBreadcrumbs.length > 0) { 
    // Get existing values
    var existingCountsJson = localStorage.getItem(STORAGE_KEY) || '{}';
    var existingCounts = JSON.parse(existingCountsJson);

    // Update counter
    productBreadcrumbs.find('a').each(function() {
      var collectionHandle = $(this).data('handle');

      if (collectionHandle) {
        if (existingCounts.hasOwnProperty(collectionHandle)) {
          existingCounts[collectionHandle] += 1;
        } else {
          existingCounts[collectionHandle] = 1;
        }
      }
    });

    // Update local storage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(existingCounts));
  }
}


/**
 * Hide Variants
 */
var productData = JSON.parse($('[data-product-json]').html());
var hiddenVariants = productData.hidden_variants;

var hideOptions = function() {
  $('.ProductForm__Option').each(function() {
    var $wrap = $(this);

    var $selectedHidenOption = $wrap.find('.HorizontalList__Item--hide input:checked, .HorizontalList__Item--hide-variant input:checked');

    if ($selectedHidenOption.length > 0) {
      var $availableOption = $wrap.find('.HorizontalList__Item:not(.HorizontalList__Item--hide):not(.HorizontalList__Item--hide-variant) input').first();
      if ($availableOption.length) {
        $availableOption.prop('checked', true);
        window._onOptionChanged($availableOption.val(), $availableOption[0]);
        // Not proud of this but what can you do when the theme JS is compiled and sucks :/
      }
    }
  });
};

var hideVariants = function() {
  var option1 = $('[name="option-0"]:checked').val();

  var variants = hiddenVariants.filter(function(variant) {
    return variant.option1 === option1;
  });

  $('.HorizontalList__Item--hide-variant').removeClass('HorizontalList__Item--hide-variant');

  variants.forEach(function(variant) {
    $('[name="option-1"][value="' + variant.option2 + '"]').parent().addClass('HorizontalList__Item--hide-variant');
  });

  hideOptions();
};

$('.ProductForm__Option input').on('change', hideVariants);

$('.template-product .Product__Usp .Product__UspItem h3').on('click', function() {
  $(this).toggleClass('open');
});


/**
 * Product Item Colors
 */
 $('body').on('click', '.js-show-all-colors', function(e) {
  e.preventDefault();
  $(this).siblings('.ProductItem__ColorSwatchItem').show();
  $(this).remove();
});

var crosssellProductList = document.querySelector('.Product__Crosssell .ProductList');
new window.ProductItemColorSwatch(crosssellProductList);

$(crosssellProductList).find('.ProductItem').each(function() {
  var $item = $(this);
  var selectedColor = $item.find('.ColorSwatch__Radio:checked').data('color-handle');
  handleColorSwitchImages($item, selectedColor);
});

var crosssellPopupProductList = document.querySelector('.ProductConfirm .Product__Crosssell .ProductList');
new window.ProductItemColorSwatch(crosssellPopupProductList);

$(crosssellPopupProductList).find('.ProductItem').each(function() {
  var $item = $(this);
  var selectedColor = $item.find('.ColorSwatch__Radio:checked').data('color-handle');
  handleColorSwitchImages($item, selectedColor);
});

var bundleProductList = document.querySelector('.Product__WrapperSide--left .Product__Bundle .ProductList');
new window.ProductItemColorSwatch(bundleProductList);

var bundleProductList2 = document.querySelector('.Product__WrapperSide--right .Product__Bundle .ProductList');
new window.ProductItemColorSwatch(bundleProductList2);

(function() {
  var colorMap = JSON.parse($('#js-color-map').html());
  $('.ColorSwatch__Radio').each(function() {
    var $item = $(this);
    var itemColor = $item.data('colorHandle');

    if (itemColor) {
      $item.data('colorSimple', colorMap[itemColor]);
      $item.attr('data-color-simple', colorMap[itemColor]);
    }
  });
})();

var buyTheLookProducts = document.querySelector('.Product__BuyLook .BuyLook__Products');
new window.ProductItemColorSwatch(buyTheLookProducts);

$('.Product__BuyLook').each(function() {
  var $bundle = $(this);

  $bundle.find('.ProductItem').each(function(itemIdx) {
    var $item = $(this);
    var variants = JSON.parse($item.data('variants'));

    $item.find('.ColorSwatch__Radio').on('change', function() {
      var colorOptionKey = $(this).data('option');
      var selectedColor = $(this).val();

      $item.find('.ProductItem__Option select').each(function() {
        var $option = $(this);
        var optionKey = $option.attr('name');

        $option.find('option').each(function() {
          const optionVal = $(this).val();
          var availableVariant = variants.find(function(variant) {
            return (
              (!variant[colorOptionKey] || variant[colorOptionKey] === selectedColor) &&
              (!variant[optionKey] || variant[optionKey] === optionVal) &&
              variant.available
            );
          });

          if (availableVariant) {
            $(this).prop('disabled', false);
          } else {
            $(this).prop('disabled', true);
          }
        });
      });
    });
  });

  $bundle.find('.ProductItem').each(function() {
    var $item = $(this);

    $item.find('.Button').on('click', function(e) {
      e.preventDefault();

      $item.find('.Product__Error').hide();
      
      var hasError = false;
      var variants = JSON.parse($item.data('variants'));
      var options = {};

      var $selectedColor = $item.find('.ColorSwatch__Radio:checked');
      var selectedColor = $selectedColor.val();
      var colorOptionKey = $selectedColor.data('option');

      options[colorOptionKey] = selectedColor;

      if (!selectedColor) {
        hasError = true;
      }

      $item.find('.ProductItem__Option select').each(function() {
        var $option = $(this);
        var optionKey = $option.attr('name');
        var optionValue = $option.val();

        options[optionKey] = optionValue;
        
        if (!optionValue) {
          hasError = true;
        }
      });

      var selectedVariant = variants.find(function(variant) {
        return (
          (!variant.option1 || variant.option1 === options.option1) && 
          (!variant.option2 || variant.option2 === options.option2) && 
          (!variant.option3 || variant.option3 === options.option3) &&
          variant.available
        );
      });

      if (!selectedVariant) {
        hasError = true;
      }


      if (hasError) {
        $item.find('.Product__Error--select').show();
      } else {
        $item.addClass('loading');
  
        jQuery.post('/cart/add.js', {
          items: [{
            id: selectedVariant.id,
            quantity: 1,
          }],
        }).then(function(response) {
          $item.removeClass('loading');
          $item.addClass('added');

          var cartCount = Number($('.js-cart-counter').text()) + 1;
          $('.js-cart-counter').html(cartCount);

          setTimeout(function() {
            $item.removeClass('added');
          }, 2000);
        }).catch(function(err) {
          console.log(err);
          $item.removeClass('loading');
          $item.find('.Product__Error--issue').show();
        });
      }
    });
  });
});


$('.Product__Bundle').each(function() {
  var $bundle = $(this);
  var preselectColorSimple;
  var preselectColor;

  $bundle.find('.ProductItem').each(function(itemIdx) {
    var $item = $(this);
    var variants = JSON.parse($item.data('variants'));

    $item.find('.ColorSwatch__Radio').on('change', function() {
      var colorOptionKey = $(this).data('option');
      var selectedColor = $(this).val();

      $item.find('.ProductItem__Option select').each(function() {
        var $option = $(this);
        var optionKey = $option.attr('name');

        $option.find('option').each(function() {
          const optionVal = $(this).val();
          var availableVariant = variants.find(function(variant) {
            return (
              (!variant[colorOptionKey] || variant[colorOptionKey] === selectedColor) &&
              (!variant[optionKey] || variant[optionKey] === optionVal) &&
              variant.available
            );
          });

          if (availableVariant) {
            $(this).prop('disabled', false);
          } else {
            $(this).prop('disabled', true);
          }
        });
      });
    });

    var $preselectColorItem = $item.find('.ColorSwatch__Radio').first();
    
    if ($preselectColorItem.length) {
      if (itemIdx === 0) {
        preselectColor = $item.find('.ColorSwatch__Radio').first().data('color');
        preselectColorSimple = $item.find('.ColorSwatch__Radio').first().data('colorSimple');
  
        var $preselectColorItem = $item.find('.ColorSwatch__Radio').first();
        $preselectColorItem.prop('checked', true);
        if ($preselectColorItem[0]) {
          $preselectColorItem[0].dispatchEvent(new Event('change', { 'bubbles': true }));
        } else {
  
        }
      } else {
        var $preselectColorItem = $item.find('.ColorSwatch__Radio[data-color-handle="' + preselectColor + '"]');
        var $preselectSimpleColorItem = $item.find('.ColorSwatch__Radio[data-color-simple="' + preselectColorSimple + '"]');
  
        if ($preselectColorItem.length) {
          $preselectColorItem.first().prop('checked', true);
          if ($preselectColorItem[0]) {
            $preselectColorItem[0].dispatchEvent(new Event('change', { 'bubbles': true }));
          }
        } else if ($preselectSimpleColorItem.length) {
          $preselectSimpleColorItem.first().prop('checked', true);
          $preselectSimpleColorItem[0].dispatchEvent(new Event('change', { 'bubbles': true }));
        } else {
          var $firstColorItem = $item.find('.ColorSwatch__Radio').first();
          $firstColorItem.first().prop('checked', true);
          if ($firstColorItem[0]) {
            $firstColorItem[0].dispatchEvent(new Event('change', { 'bubbles': true }));
          }
        }
      }
    } else {
      $item.find('.js-product-images-main').addClass('Image--lazyLoad');
    }
  });

  // $bundle.find('.Button').on('click', function(e) {
  //   e.preventDefault();

  //   $bundle.find('.Product__BundleError').hide();

  //   var selectedVariants = [];
  //   var hasError = false;

  //   $bundle.find('.ProductItem').each(function() {
  //     var $item = $(this);
  //     var variants = JSON.parse($item.data('variants'));
  //     var options = {};
      
  //     var $selectedColor = $item.find('.ColorSwatch__Radio:checked');
  //     var selectedColor = $selectedColor.val();
  //     var colorOptionKey = $selectedColor.data('option');
      
  //     options[colorOptionKey] = selectedColor;

  //     if (!selectedColor) {
  //       console.log('ERR: no selected color');
  //       hasError = true;
  //     }

  //     $item.find('.ProductItem__Option select').each(function() {
  //       var $option = $(this);
  //       var optionKey = $option.attr('name');
  //       var optionValue = $option.val();

  //       options[optionKey] = optionValue;
        
  //       if (!optionValue) {
  //         console.log('ERR: no selected option');
  //         hasError = true;
  //       }
  //     });

  //     var selectedVariant = variants.find(function(variant) {
  //       return (
  //         (!variant.option1 || variant.option1 === options.option1) && 
  //         (!variant.option2 || variant.option2 === options.option2) && 
  //         (!variant.option3 || variant.option3 === options.option3) &&
  //         variant.available
  //       );
  //     });

  //     if (selectedVariant) {
  //       selectedVariants.push(selectedVariant.id);
  //     } else {
  //       hasError = true;
  //     }
  //   });

  //   if (hasError) {
  //     $bundle.find('.Product__BundleError--select').show();
  //   } else {
  //     $bundle.find('.Product__ButtonWrap').addClass('loading');
  //     var items = selectedVariants.map(function(id) {
  //       return {
  //         id: id,
  //         quantity: 1,
  //       };
  //     });

  //     jQuery.post('/cart/add.js', {
  //       items: items,
  //     }).then(function(response) {
  //       window.location.href = '/cart';
  //     }).catch(function(err) {
  //       console.log(err);
  //       $bundle.find('.Product__ButtonWrap').removeClass('loading');
  //       $bundle.find('.Product__BundleError--issue').show();
  //     });
  //   }
  // });
});

hideVariants();
hideOptions();


const trackAddToCart = function(productIds) {
  if (!gtag) return;

  gtag("event", 'add_to_cart', {
    items: productIds.map(function(id) {
      return {
        item_id: id,
      };
    }),
  });
};

$('.js-product-addtocart-wrap').on('click', 'button', function() {
  var producId = $(this).data('id');
  trackAddToCart([producId]);
});

$('.js-look-atc').on('click', function() {
  var producId = $(this).data('id');
  trackAddToCart([producId]);
});

$('.js-bundle-atc').on('click', function() {
  var producIds = $(this).data('id').split(',');
  trackAddToCart(producIds);
});

(() => {
  const productForm = document.querySelector('.Product__Info .ProductForm');
  const fixedCTA = document.querySelector('.Product__FixedCTA');
  
  if (productForm && fixedCTA) {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };
    
    const callback = (changes) => {
      changes.forEach((change) => {
        if (change.intersectionRatio > 0) {
          fixedCTA.classList.remove('Product__FixedCTA--visible');

          const labels = fixedCTA.querySelectorAll('.ProductForm__Label');
          labels.forEach((label) => {
            label.classList.remove('ProductForm__Label--open');
          });
        } else {
          fixedCTA.classList.add('Product__FixedCTA--visible');
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(productForm);
  }

  if (fixedCTA) {
    const optionLabels = fixedCTA.querySelectorAll('.ProductForm__Label');

    // Toggle option value lists
    optionLabels.forEach((label) => {
      label.addEventListener('click', () => {        
        optionLabels.forEach((otherLabel) => {
          if (otherLabel !== label) {
            otherLabel.classList.remove('ProductForm__Label--open');
          }
        });
        
        label.classList.toggle('ProductForm__Label--open');
      });
    });

    // Close option value lists when an option is selected
    const options = fixedCTA.querySelectorAll('.ProductForm__Option input');
    options.forEach((option) => {
      option.addEventListener('change', () => {
        const label = option.closest('.ProductForm__Option').querySelector('.ProductForm__Label');
        label.classList.remove('ProductForm__Label--open');
      });
    });
  }
})();

$('[data-connected-variant]').on('click', function(e) {
  e.preventDefault();
  $(this).addClass('loading');
  const url = $(this).attr('href');
  
  setTimeout(function() {
    window.location.href = url;
  }, 200);
  
})